// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClickableController from "./clickable_controller"
application.register("clickable", ClickableController)

import ClickableRowController from "./clickable_row_controller"
application.register("clickable-row", ClickableRowController)

import CodemirrorController from "./codemirror_controller"
application.register("codemirror", CodemirrorController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import DirtyFormController from "./dirty_form_controller"
application.register("dirty-form", DirtyFormController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import FormController from "./form_controller"
application.register("form", FormController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import OffcanvasController from "./offcanvas_controller"
application.register("offcanvas", OffcanvasController)

import ScrolledController from "./scrolled_controller"
application.register("scrolled", ScrolledController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SnapScrollController from "./snap_scroll_controller"
application.register("snap-scroll", SnapScrollController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
